module.exports = __webpack_public_path__ + "static/media/image10.da981760.png";